import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import AdminPageHeader from "../../components/common/AdminPageHeader";
import WithdrawalAdminPanel from "../../components/admin/WithdrawalAdminPanel";

const WithdrawalAdminPage = () => {
  return (
    <MasterLayout>
      <div className="dashboard-main-body">
        <AdminPageHeader
          icon="solar:wallet-money-bold"
          title="Solicitações de Saque"
          subtitle="Administre e aprove solicitações de saque dos usuários"
        />

        {/* WithdrawalAdminPanel */}
        <WithdrawalAdminPanel />
      </div>
    </MasterLayout>
  );
};

export default WithdrawalAdminPage;


